// src/context/CircuitoContext.js
"use client"

import { createContext, useEffect, useState } from "react"
import axios from "axios"

export const CircuitoContext = createContext(null)

export function CircuitoProvider({ slug, children }) {
  const [circuito, setCircuito] = useState(null)
  const [eventosCircuito, setEventosCircuito] = useState([])
  const [loadingCircuito, setLoadingCircuito] = useState(true)
  const [erroCircuito, setErroCircuito] = useState("")

  useEffect(() => {
    if (!slug) return

    const carregarCircuito = async () => {
      try {
        setLoadingCircuito(true)
        setErroCircuito("")

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com/api"}/circuitos/slug/${slug}`
        )

        const { circuito: circuitoData, eventos } = res.data

        setCircuito(circuitoData || null)
        setEventosCircuito(eventos || [])

      } catch (e) {
        console.error("Erro ao carregar circuito:", e?.response?.data || e.message)
        setErroCircuito("Circuito não encontrado ou indisponível.")
      } finally {
        setLoadingCircuito(false)
      }
    }

    carregarCircuito()
  }, [slug])

  // 💡 MÁGICA WHITE-LABEL: Injeta o Título e Favicon dinamicamente na Aba
  useEffect(() => {
    if (circuito) {
      // 1. Muda o nome da Aba
      document.title = circuito.nome || "Circuito de Vaquejada";

      // 2. Muda a foto da Aba (Favicon)
      if (circuito.imagem) {
        const faviconUrl = `https://api.ticketdovaqueiro.com/uploads/${circuito.imagem}`;
        let link = document.querySelector("link[rel~='icon']");
        
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = faviconUrl;
      }
    }
  }, [circuito])

  return (
    <CircuitoContext.Provider
      value={{
        circuito,
        eventosCircuito,
        loadingCircuito,
        erroCircuito,
      }}
    >
      {children}
    </CircuitoContext.Provider>
  )
}